export default "__VITE_ASSET__DWwVbsIv__"